<template>
    <v-card flat>
        <v-container fluid class="pa-4">
            <v-row dense>

                <!-- INFO DIALOGS -->
                <v-col cols="12" class="pb-2">
                    <v-row align-center justify-center row fill-height>
                        <v-col cols="12" v-show="userLocalizable">
                            <v-alert type="info" class="body-2 mb-0">
                                Question validators are used in the dynamic profiling and in the registration survey.
                            </v-alert>
                        </v-col>
                        <v-col cols="12" v-show="!userLocalizable">
                            <v-alert type="warning" prominent class="body-2 mb-0">
                                This is non writable system variable and therefore custom validators are not possible.
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <div v-if="userLocalizable">

            <div class="d-flex justify-end mr-5">
                <v-btn text class="align-self-center" color="white" @click="previewQuestion">
                    <v-icon left>mdi-eye</v-icon>
                    Preview question
                </v-btn>

                <help-icon class="align-self-center text-right" help="edit-datavariables-validators"></help-icon>
            </div>

            <v-container fluid class="pr-5 pl-5">
                <v-row dense>

                    <!-- VALIDATION OPTIONS -->
                    <v-col cols="12" v-if="variable">
                        <validation :variable="variable"
                                    @change="validatorsChanged"
                        ></validation>
                    </v-col>
                </v-row>

            </v-container>
        </div>

        <preview-question-dialog v-if="selectedLocale"
                                 v-model="previewQuestionDialogModel"
                                 :answer="null"
                                 :locale="selectedLocale"
                                 :variable="dataVariable"
        ></preview-question-dialog>

        <json v-if="debug" :data="variable"></json>

    </v-card>
</template>

<script>

import Json from 'vue-json-pretty';
import TitleCard from "../../../../components/UI/TitleCard";
import Validation from "../Validation";
import PreviewQuestionDialog from "../PreviewQuestionDialog";
import HelpIcon from "../../../../components/UI/HelpIcon";

export default {

    components: {
        HelpIcon,
        Json,
        TitleCard,
        Validation,
        PreviewQuestionDialog
    },

    props: {
        dataVariable: {
            type: Object | null,
            required: true,
        },
        availableLocales: {
            type: Array | null,
            required: true,
        }
    },
    data() {
        return {
            debug: false,
            variable: null,
            previewQuestionDialogModel: false,
        }
    },
    watch: {
        // Async loading watch
        dataVariable(variable) {
            // Deep clone
            this.variable = JSON.parse(JSON.stringify(variable));
        },
    },
    mounted() {
        // If user is coming from the list page (both props are populated)
        if (this.dataVariable) {
            this.variable = JSON.parse(JSON.stringify(this.dataVariable));
        }
    },

    computed: {

        selectedLocale() {
            if (this.availableLocales && this.variable) {
                return this.availableLocales.find(locale => locale.id === this.variable.locales[0].locale_id);
            }
        },

        userLocalizable() {
            if (this.variable) {
                return this.variable.user_localizable;
            }
            return false
        },
    },

    methods: {

        validatorsChanged(validators) {
            this.variable.dynamic_profiling_validators = validators;
            this.emit();
        },

        previewQuestion() {
            this.previewQuestionDialogModel = true;
        },

        emit() {
            this.$emit('change', this.variable);
        }
    }
}
</script>
